export const ka = {
  title: 'ქარის სიჩქარის პოტენციალი',
  subtitle: '1 კმ, გლობალური, DTU/World Bank Group/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'ფუნქცია',
      value: 'ნიშნავს ქარის სიჩქარეს დედამიწის ნებისმიერი ადგილისთვის',
    },
    {
      label: 'რეზოლუცია',
      value: '1 კმ',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური',
    },
    {
      label: 'წყარო',
      value: '\tდტუ/მსოფლიო ბანკის ჯგუფი/ESMAP',
    },
    {
      label: 'სიხშირე',
      value: '',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '',
    },
    {
      label: 'გაფრთხილება',
      value:
        'GWA იყენებს ორ ძირითად მოდელირების კომპონენტს, რომელსაც შეუძლია გაურკვევლობის დანერგვა გამოთვლებში. ეს კომპონენტები არის მეზოსური მოდელირება და მიკრომასშტაბური მოდელირება.',
    },
    {
      label: 'ლიცენზია',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'გლობალური ქარის ატლასი (GWA) ნიშნავს ქარის სიჩქარის მონაცემთა ბაზას დანიის ტექნიკური უნივერსიტეტის (DTU), მსოფლიო ბანკის ჯგუფისა და ენერგეტიკის სექტორის მართვის დახმარების პროგრამის (ESMAP) ქარის ენერგიის დეპარტამენტის მიერ.\n\nნიშნავს ქარის სიჩქარე ქარის ენერგიის წარმოების ერთ-ერთი მთავარი მაჩვენებელია. GWA იწყება დაბალი რეზოლუციის ქარის სიჩქარის მონაცემებით და გარდაქმნის მას მაღალი რეზოლუციის მონაცემებად შემცირების პროცესის გამოყენებით. ამ პროცესის შედეგია ადგილობრივი ქარის კლიმატის მოდელი მთელს მსოფლიოში (გარდა ჩრდილოეთ და სამხრეთ პოლუსებისა და შორეული ოკეანის ტერიტორიებისა) 1 კილომეტრის რეზოლუციით სამი სიმაღლისთვის: 50 მეტრი, 100 მეტრი და 200 მეტრი.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
